import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';
import { CategoryNode, CategoryTypeName } from './growCategoryRestriction.types';
import { ICON_COLOR } from './growCategoryRestriction.visual';

export const renderCategoryExpandIcon = (hasChildren: boolean, isExpanded: boolean) => {
    if (!hasChildren) {
        return null;
    }
    if (isExpanded) {
        return <ExpandMoreIcon sx={{ fontSize: 15 }} />;
    }
    return <ChevronRightIcon sx={{ fontSize: 15 }} />;
};

export const renderHierarchyExpandIcon = (
    isLoadingChildren: boolean | undefined,
    expandable: boolean,
    isExpanded: boolean | undefined
) => {
    if (isLoadingChildren) {
        return null;
    }
    if (!expandable) {
        return null;
    }
    if (isExpanded) {
        return <ExpandMoreIcon sx={{ fontSize: 16 }} />;
    }
    return <ChevronRightIcon sx={{ fontSize: 16 }} />;
};

export const getRestrictionRowStyles = (isRestricted: boolean, color: string, hasChildren: boolean) => ({
    cursor: hasChildren ? 'pointer' : 'default',
    backgroundColor: isRestricted ? 'rgba(239,68,68,0.04)' : 'transparent',
    borderLeft: isRestricted ? '2px solid rgba(239,68,68,0.45)' : `2px solid ${color}22`,
    hoverBackgroundColor: isRestricted ? 'rgba(239,68,68,0.07)' : `${color}0a`,
    hoverBorderLeftColor: isRestricted ? 'rgba(239,68,68,0.7)' : `${color}66`,
});

export const getRestrictionTypographySx = (node: CategoryNode, isRestricted: boolean) => {
    const isZone = node.typeName === 'zone';
    const isTopCategory = node.typeName === 'topCategory';
    let color: string = 'text.primary';
    if (!node.isActive) color = 'text.disabled';
    else if (isRestricted) color = 'error.dark';

    return {
        minWidth: 0,
        fontSize: isZone ? 12.5 : 12,
        fontWeight: isZone ? 600 : isTopCategory ? 500 : 400,
        color,
        letterSpacing: isZone ? '0.01em' : 0,
    };
};

export const getHierarchyRowStyles = (
    node: CategoryNode,
    isRestricted: boolean,
    expandable: boolean,
    rowBg: Record<CategoryTypeName, string>
) => {
    let borderLeft = '2px solid transparent';
    if (isRestricted) borderLeft = '2px solid rgba(239,68,68,0.5)';
    else if (node.typeName === 'zone') borderLeft = '2px solid rgba(25,118,210,0.2)';

    return {
        cursor: expandable ? 'pointer' : 'default',
        backgroundColor: isRestricted ? 'rgba(239,68,68,0.04)' : rowBg[node.typeName],
        borderLeft,
        hoverBackgroundColor: isRestricted ? 'rgba(239,68,68,0.07)' : 'rgba(25,118,210,0.06)',
        hoverBorderLeftColor: isRestricted ? 'rgba(239,68,68,0.7)' : ICON_COLOR[node.typeName] + '66',
    };
};

export const getHierarchyTypographySx = (node: CategoryNode, isRestricted: boolean) => {
    const isZone = node.typeName === 'zone';
    const isTopCategory = node.typeName === 'topCategory';
    const isProductType = node.typeName === 'productType';
    let color: string = 'text.primary';
    if (!node.isActive) color = 'text.disabled';
    else if (isRestricted) color = 'error.dark';

    return {
        minWidth: 0,
        fontSize: isProductType ? 12 : isZone ? 13.5 : 13,
        fontWeight: isZone ? 600 : isTopCategory ? 500 : 400,
        color,
        letterSpacing: isZone ? '0.01em' : 0,
    };
};

export const ChildCountBadge = ({ count }: { count: number }) => {
    if (count <= 0) return null;
    return (
        <Typography
            component="span"
            sx={{
                flexShrink: 0,
                fontSize: 10,
                fontWeight: 700,
                color: '#1976d2',
                bgcolor: '#e3f2fd',
                borderRadius: '10px',
                px: '6px',
                py: '1px',
                lineHeight: 1.6,
                whiteSpace: 'nowrap',
                border: '1px solid #bbdefb',
            }}
        >
            {count}
        </Typography>
    );
};
